import React, { useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices } from 'hook/services';
import { Button, Stack, TextareaAutosize } from '@mui/material';
import Editor from 'components/editor'

const EditModal = ({ data, handleRefresh }) => {
  console.log(data, "datadata")
  const AppService = useAppServices();
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [svgIcon, setSvgIcon] = useState(null);
  const [description,setDescription] = useState(data.description)


  const handleModal = () => {
    setOpenEditProduct(true);
  };

  const closeEditProduct = () => {
    setOpenEditProduct(false);
  };

  const handleSvgUpload = (e) => {
    setSvgIcon(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);


    const payload = {
      _id: data._id,
      title: e.target.title.value,
      description,
      transcript: e.target.transcript.value,
      video: e.target.video.value,

    };

    console.log(payload, "payload");

    const { response } = await AppService.exchangepodcast.update({ payload });

    if (response) {
      setProcessing(false);
      // closeAddProduct();
      setOpenEditProduct(false);

      handleRefresh();
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={style}
            encType="multipart/form-data"
          >
            <MDTypography variant="h5" mb={2}>
              Edit
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Title</MDTypography>
              <MDInput label="Title" name="title" fullWidth defaultValue={data.title} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} data={description} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Transcript</MDTypography>
              <TextareaAutosize
                className="form-control"
                style={{ minHeight: '70px' }}
                placeholder="transcript"
                name="transcript"
                defaultValue={data.transcript}
              />
              {/* <MDInput label="transcript" name="transcript" fullWidth defaultValue={data.transcript} /> */}
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Video</MDTypography>
              <MDInput label="video" name="video" fullWidth defaultValue={data.video} />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
};

export default EditModal;
